const redirectToSpace = (space) => {
  const { protocol, host } = window.location;

  window.location.replace(`${protocol}//${host}/${space}`);
};

export default redirectToSpace;
